module.exports = __webpack_public_path__ + "static/media/mx.9694b47e.svg";